<script lang="ts">
  // Answers a question from inside a card. The words are the buyer's own — this is the
  // one place a control carries text, and the text travels in the direction that makes
  // that harmless.

  import { t } from '$lib/i18n/index.svelte';

  import type { ElementContext } from '../context';

  let { ctx, questionId }: { ctx: ElementContext; questionId: string | undefined } = $props();

  let text = $state('');
  let sent = $state(false);

  const ready = $derived(
    questionId !== undefined && text.trim().length > 0 && !ctx.disabled && !sent,
  );

  function send(): void {
    if (questionId === undefined || !ready) {
      return;
    }
    ctx.onAnswer(questionId, text.trim());
    text = '';
    sent = true;
  }
</script>

<span class="row">
  <input
    type="text"
    bind:value={text}
    disabled={ctx.disabled || sent}
    aria-label={t('views.control.answer')}
    onkeydown={(e) => {
      if (e.key === 'Enter') {
        send();
      }
    }}
  />
  <button type="button" disabled={!ready} onclick={send}>{t('views.control.answer')}</button>
</span>

<style>
  .row {
    display: inline-flex;
    gap: 8px;
    align-items: center;
  }
  input {
    border: 1px solid var(--line);
    border-radius: 8px;
    background: transparent;
    color: inherit;
    font: inherit;
    padding: 8px 10px;
    min-width: 8em;
  }
  button {
    border: 1px solid var(--line);
    border-radius: 10px;
    background: var(--surface);
    color: var(--ink);
    font: inherit;
    padding: 9px 14px;
    cursor: pointer;
  }
  button:disabled,
  input:disabled {
    opacity: 0.5;
    cursor: default;
  }
</style>
